<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18sC58/tc-custom/9781426822704.jpg?1706909082847" alt="This image is the cover for the book Purchased: His Perfect Wife, Wedlocked!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Purchased: His Perfect Wife, Wedlocked!
      </h1>
      <p class="bookDescription body article font2">
        <b>A bailout from a billionaire comes at a price: one woman’s independence—and her heart. From the <i>USA Today</i>–bestselling author.</b><br/><br/>Lara’s beloved restaurant is in crisis. There’s only one man who can help—Wolfe Alexander, her tall, dark, brooding stepbrother. Wolfe lives up to his name: he demands that, in exchange for his money, Lara must become his convenient wife!<br/><br/>With no choice but to accept Wolfe’s terms, Lara is soon swept into his world of high-society glamour beyond her wildest dreams—and into the passion of his bed. But there is just one thing missing—her husband’s love . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Bianchin
      </h2>
      
      <p class="authorDescription body article">Helen Bianchin was encouraged by a friend to write her own romance novel and she hasn&rsquo;t stopped writing since! Helen&rsquo;s interests include a love of reading, going to the movies, and watching selected television programs. She also enjoys catching up with friends, usually over a long lunch! A lover of animals, especially cats, she owns two beautiful Birmans. Helen lives in Australia with her husband. Their three children and six grandchildren live close by.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b4c0a3d